import RepositoryService from 'src/services/repository'

function getResource (gameId) {
  return `multiProject/session/${gameId}/round`
}

export default {
  get: async gameId => {
    const resource = getResource(gameId)
    const response = await RepositoryService.base.get(resource)
    return response?.data ?? response
  },
  patch: async (gameId, data) => {
    const resource = getResource(gameId)
    const response = await RepositoryService.base.patch(resource, data)
    return response?.data ?? response
  },
}
